<label class="label">
  <span class="control">
    <ng-content></ng-content>
  </span>

  <span class="circle"></span>

  <ng-content select="[label]"></ng-content>
</label>
